{
  "version": 1,
  "asset_id": "96ccf60d-8a08-4a67-96cf-05534cddd5ae",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/96ccf60d-8a08-4a67-96cf-05534cddd5ae/hernando-galvalume-metal-roof-aerial-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/96ccf60d-8a08-4a67-96cf-05534cddd5ae/hernando-galvalume-metal-roof-aerial-768w.webp",
  "original_filename": "hernando-galvalume-metal-roof-aerial-768w.webp",
  "size": 63674,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
